<div class="modal" data-id="evs-modal" hidden>
  <div class="modal__backdrop" data-id="evs-backdrop"></div>

  <form class="modal__dialog modal__dialog--wide" data-id="evs-form-el" role="dialog" aria-modal="true"
        aria-labelledby="evs-form-title" novalidate>
    <header class="modal__header">
      <h2 class="modal__title" id="evs-form-title" data-id="evs-title"><%= _lcs( 'Datenquelle bearbeiten' ) %></h2>
      <button type="button" class="iconbtn modal__close" data-id="evs-close" aria-label="<%= _lcs( 'Schließen' ) %>">
        <i class="icon icon--x"></i>
      </button>
    </header>

    <div class="modal__body">
      <p class="modal__error" data-id="evs-error" hidden></p>

      <p class="evs-form__key">
        <i class="icon icon--tags"></i>
        <span data-id="evs-key">–</span>
        <span class="evs-form__key-note"><%= _lcs( 'Schlüssel, Adapter und Inhaltstyp sind fest — an ihnen hängen alle bereits importierten Datensätze.' ) %></span>
      </p>

      <!-- ============================ Allgemein ============================ -->
      <h3 class="evs-form__legend"><%= _lcs( 'Allgemein' ) %></h3>

      <div class="field">
        <label class="field__label" for="evs-name"><%= _lcs( 'Name' ) %></label>
        <div class="field__control">
          <span class="field__icon"><i class="icon icon--layers"></i></span>
          <input class="field__input" id="evs-name" name="name" type="text" required
                 maxlength="160" autocomplete="off"
                 data-msg-required="<%= _lcs( 'Bitte gib einen Namen ein.' ) %>" />
        </div>
      </div>

      <div class="field">
        <label class="field__label" for="evs-description"><%= _lcs( 'Beschreibung' ) %></label>
        <div class="field__control field__control--textarea">
          <textarea class="field__input" id="evs-description" name="description" rows="2" maxlength="2000"></textarea>
        </div>
      </div>

      <div class="field">
        <label class="field__label" for="evs-region"><%= _lcs( 'Region' ) %></label>
        <div class="field__control">
          <span class="field__icon"><i class="icon icon--map-pin"></i></span>
          <select class="field__input field__select" id="evs-region" name="region"></select>
        </div>
        <p class="field__note"><%= _lcs( 'Alle Datensätze dieser Quelle werden dieser Region zugeordnet.' ) %></p>
      </div>

      <label class="checkbox evs-form__toggle">
        <input type="checkbox" id="evs-enabled" name="isEnabled" />
        <span class="checkbox__box"><i class="icon icon--check"></i></span>
        <%= _lcs( 'Quelle aktiv — wird beim täglichen Import berücksichtigt' ) %>
      </label>

      <!-- ============================ Verbindung =========================== -->
      <h3 class="evs-form__legend"><%= _lcs( 'Verbindung' ) %></h3>

      <div class="field">
        <label class="field__label" for="evs-endpoint"><%= _lcs( 'Endpunkt (URL)' ) %></label>
        <div class="field__control">
          <span class="field__icon"><i class="icon icon--send-horizontal"></i></span>
          <input class="field__input" id="evs-endpoint" name="endpoint" type="url" maxlength="500"
                 placeholder="https://meta.et4.de/rest.ashx/search/" autocomplete="off" />
        </div>
      </div>

      <div class="field">
        <label class="field__label" for="evs-experience">Experience</label>
        <div class="field__control">
          <span class="field__icon"><i class="icon icon--compass"></i></span>
          <input class="field__input" id="evs-experience" name="experience" type="text" maxlength="120"
                 placeholder="open-data-sachsen-tourismus" autocomplete="off" />
        </div>
        <p class="field__note"><%= _lcs( 'Der Datenpool, den der Lizenzschlüssel freischaltet.' ) %></p>
      </div>

      <div class="field">
        <label class="field__label" for="evs-licensekey"><%= _lcs( 'Lizenzschlüssel' ) %></label>
        <div class="field__control">
          <span class="field__icon"><i class="icon icon--key-round"></i></span>
          <input class="field__input" id="evs-licensekey" name="licenseKey" type="text" maxlength="200"
                 autocomplete="off" data-id="evs-licensekey" />
        </div>
        <p class="field__note">
          <i class="icon icon--shield-check"></i>
          <%= _lcs( 'Leer lassen, um den gespeicherten Schlüssel unverändert zu übernehmen.' ) %>
        </p>
      </div>

      <div class="evs-form__row">
        <div class="field">
          <label class="field__label" for="evs-template">Template</label>
          <div class="field__control">
            <input class="field__input" id="evs-template" name="template" type="text" maxlength="120"
                   placeholder="ET2014A_LIGHT.json" autocomplete="off" />
          </div>
        </div>
        <div class="field">
          <label class="field__label" for="evs-type"><%= _lcs( 'Datentyp beim Anbieter' ) %></label>
          <div class="field__control">
            <input class="field__input" id="evs-type" name="type" type="text" maxlength="40"
                   placeholder="Event" autocomplete="off" />
          </div>
        </div>
      </div>

      <!-- ============================== Import ============================= -->
      <h3 class="evs-form__legend"><%= _lcs( 'Import' ) %></h3>

      <div class="evs-form__row">
        <div class="field">
          <label class="field__label" for="evs-months"><%= _lcs( 'Zeitraum (Monate)' ) %></label>
          <div class="field__control">
            <span class="field__icon"><i class="icon icon--calendar-days"></i></span>
            <input class="field__input" id="evs-months" name="months" type="number" min="1" max="36" step="1" />
          </div>
          <p class="field__note"><%= _lcs( 'Ab heute in die Zukunft.' ) %></p>
        </div>
        <div class="field">
          <label class="field__label" for="evs-maxdistance"><%= _lcs( 'Umkreis (km)' ) %></label>
          <div class="field__control">
            <span class="field__icon"><i class="icon icon--navigation"></i></span>
            <input class="field__input" id="evs-maxdistance" name="maxDistanceKm" type="number" min="1" max="500" step="1"
                   placeholder="<%= _lcs( 'ohne Begrenzung' ) %>" />
          </div>
          <p class="field__note"><%= _lcs( 'Um den Mittelpunkt der Region. Leer = alles übernehmen.' ) %></p>
        </div>
      </div>

      <div class="evs-form__row">
        <div class="field">
          <label class="field__label" for="evs-pagesize"><%= _lcs( 'Einträge pro Abruf' ) %></label>
          <div class="field__control">
            <input class="field__input" id="evs-pagesize" name="pageSize" type="number" min="1" max="500" step="1" />
          </div>
        </div>
        <div class="field">
          <label class="field__label" for="evs-maxpages"><%= _lcs( 'Max. Abrufe' ) %></label>
          <div class="field__control">
            <input class="field__input" id="evs-maxpages" name="maxPages" type="number" min="1" max="500" step="1" />
          </div>
        </div>
      </div>

      <label class="checkbox evs-form__toggle">
        <input type="checkbox" id="evs-autopublish" name="autoPublish" />
        <span class="checkbox__box"><i class="icon icon--check"></i></span>
        <%= _lcs( 'Importierte Veranstaltungen sofort veröffentlichen' ) %>
      </label>

      <label class="checkbox evs-form__toggle">
        <input type="checkbox" id="evs-detectduplicates" name="detectDuplicates" />
        <span class="checkbox__box"><i class="icon icon--check"></i></span>
        <%= _lcs( 'Dubletten anderer Quellen erkennen' ) %>
      </label>
      <p class="field__note">
        <i class="icon icon--layers"></i>
        <%= _lcs( 'Veranstaltungen, die eine andere Quelle bereits geliefert hat, werden erkannt (Titel, Datum und Ort) und Gästen nur einmal angezeigt. Beide Datensätze bleiben erhalten.' ) %>
      </p>

      <!-- ============================== Bilder ============================= -->
      <h3 class="evs-form__legend"><%= _lcs( 'Bilder' ) %></h3>

      <label class="checkbox evs-form__toggle">
        <input type="checkbox" id="evs-mirrorimages" name="mirrorImages" />
        <span class="checkbox__box"><i class="icon icon--check"></i></span>
        <%= _lcs( 'Bilder in unseren Speicher kopieren statt zu verlinken' ) %>
      </label>
      <p class="field__note">
        <i class="icon icon--shield-check"></i>
        <%= _lcs( 'Kopiert werden nur Bilder mit einer passenden Lizenz (CC0, CC-BY, CC-BY-SA) — jeweils mit Bildnachweis. Alle anderen bleiben beim Anbieter verlinkt.' ) %>
      </p>

      <div class="field">
        <label class="field__label" for="evs-imagemaxpixels"><%= _lcs( 'Maximale Bildkante (px)' ) %></label>
        <div class="field__control">
          <span class="field__icon"><i class="icon icon--image"></i></span>
          <input class="field__input" id="evs-imagemaxpixels" name="imageMaxPixels" type="number"
                 min="320" max="4000" step="10" />
        </div>
        <p class="field__note">
          <%= _lcs( 'Anbieter liefern unbearbeitete Originale (im Schnitt 1,5 MB, teils über 70 MB). Beim Kopieren werden sie auf diese Kantenlänge verkleinert und als WebP gespeichert.' ) %>
        </p>
      </div>
    </div>

    <footer class="modal__footer">
      <button type="button" class="btn btn--ghost btn--sm" data-id="evs-cancel"><%= _lcs( 'Abbrechen' ) %></button>
      <button type="submit" class="btn btn--primary btn--sm" data-id="evs-submit">
        <span data-id="evs-submit-label"><%= _lcs( 'Speichern' ) %></span>
      </button>
    </footer>
  </form>
</div>
